export default [
  {
    path: '/supplier/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'supplierList',
        component: () => import('@/views/Supplier/SupplierList.vue'),
        meta: {
          prev: 'BAHome',
          keepAlive: true
        }
      },
      {
        path: 'supplierEdit',
        name: 'supplierEdit',
        component: () => import('@/views/Supplier/SupplierEdit.vue'),
        meta: {
          prev: 'supplierList'
        }
      },
      {
        path: 'supplierDetail',
        name: 'supplierDetail',
        component: () => import('@/views/Supplier/SupplierDetail.vue'),
        meta: {
          prev: 'supplierList'
        }
      }
    ]
  }
]
